import { LitElement, html, css } from 'lit'
import { StoreMixin } from '../store.js'

// Authenticated landing (behind the auth guard from Phase 1). Phase 2 replaces
// the root route with the ticket list (<page-tickets>), per functional-spec §12.
class PageHome extends StoreMixin(LitElement) {
  static properties = { params: { type: Array } }

  static styles = css`
    .card { background: var(--bx-surface); border: 1px solid var(--bx-border);
            border-radius: var(--bx-radius); box-shadow: var(--bx-shadow);
            padding: 2rem; margin-top: 2rem; }
    h1 { color: var(--bx-brand); margin: 0 0 0.5rem; }
    p { color: var(--bx-muted); margin: 0.25rem 0; }
    .badge { display: inline-block; margin-top: 1rem; padding: 0.35rem 0.7rem;
             background: var(--bx-accent); color: var(--bx-accent-ink);
             border-radius: 999px; font-weight: 600; font-size: 0.8rem; }
  `

  render() {
    const { user } = this.appState
    const who = user?.fullName || user?.email || 'there'
    const roleLabel = user?.role === 'agent' ? 'support agent' : 'client'
    return html`
      <div class="card">
        <h1>Welcome, ${who}</h1>
        <p>You're signed in as a ${roleLabel}.</p>
        <p>Tickets, the knowledge base, and the rest arrive in the next phases.</p>
        <span class="badge">Phase 1 · Auth & Identity</span>
      </div>
    `
  }
}

customElements.define('page-home', PageHome)
